<template>
  <div class="vcenter">
    <div class="login-alert" v-if="isAlert"><i class="el-icon-error login-icon"></i>{{ alertMsg }}</div>
    <el-form class="login-form" ref="form" :model="form" status-icon v-loading="loading"
      size="medium" @keyup.enter.native="submitForm('form')">
      <h2 class="login-header">WELCOME</h2>
      <el-form-item prop="username">
        <el-input v-model="form.username" placeholder="Email"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" style="width: 100%; font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="submitForm('form')" >Login</el-button>
      </el-form-item>
      <div style="text-align: center;"><a @click="forgotPassword()">Forgot Password?</a></div>
      <!-- <div style="text-align: center;"><a @click="forgotPassword()">Create Password</a></div> -->
    </el-form>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'
import MFA_HTTP_API from '@/utils/mfa-http-api'
import PRE_HTTP_API from '@/utils/pre-http-api'
import * as cognosLaunch from '../utils/cognoslaunch.js';

export default {
  name: 'Login',
  data () {
    return {
      alertMsg: 'Username / Password is not valid.',
      form: { username: '', password: '' },
      isAlert: false,
      loading: false,
      lenderId:'', 
      countDown:0
    }
  },
  methods: {
    submitForm() {
      var vm= this;
      vm.loading = true
      sessionStorage.clear();
     
      var encoded_client = btoa(process.env.VUE_APP_WEB_CLIENT + ':' + process.env.VUE_APP_WEB_GRANT, 'base64')
      let params = new FormData()
      params.append('username', this.form.username)
      params.append('password', this.form.password)
      params.append('grant_type', 'password')
      var userName = this.form.username;
      
      HTTP_API.post('/token', params, {headers: {Authorization: 'Basic ' + encoded_client}})
        .then(function (response) {
          console.log("Username and password login Successful")
          console.log(response.data)

          var expDate = new Date();
          let expDateStorage  = expDate.getTime() + (response.data.expires_in*1000) - (60*1000)
          sessionStorage.setItem('expDate',expDateStorage)

          vm.countDown = response.data.expires_in
          vm.countDownTimer()
          var isMFA = response.data.isMFA;
          if(isMFA){
            sessionStorage.setItem('pre-web-token',response.data.access_token)
            vm.generateQRCode();
          } else {
            sessionStorage.setItem('web-token',response.data.access_token)
            vm.userAdditionalInfo()
          }
          vm.loading = false
        })
        .catch(function (error) {
          console.log(error.response)
          vm.loading = false
          vm.isAlert = true
          if (error.response.data == ''){
            vm.alertMsg = "Invalid Username or Password."
          }else{
            vm.alertMsg = error.response.data.error_description;
          }
        })
    },
    userAdditionalInfo(){
      var vm = this
      HTTP_API.get('/base/useradditionalinfo')
      .then(response => {
        vm.lenderId =  response.data
        vm.getCusipAgreementDate()
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    getCusipAgreementDate(){
      var vm = this
      HTTP_API.get('/account/cusipagreementdate')
      .then(response => {
       var cusipDate = response.data;
       if(cusipDate === null || !cusipDate){
          vm.$router.push({ name: "cusipagreement"})
       } else {
          vm.$router.push({ name: "home",params: {lenderId: parseInt(vm.lenderId)} })
       }
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    forgotPassword() {
      this.$router.push({ name: 'forgotpassword' })
    },
    generateQRCode() {
        var vm = this
        MFA_HTTP_API.post('/auth/generateqrcode').then(response => {
 
        var qrCodeImg = response.data.qrCode;
        var mfaCode = response.data.mfaCode;
        var nextPage = response.data.page;
        if(nextPage == process.env.VUE_APP_QR_PAGE){
          sessionStorage.setItem('mfaCode',mfaCode)
          sessionStorage.setItem('qrCodeImg',qrCodeImg)
          vm.$router.push({ name: "qr"})

        } else if(nextPage == process.env.VUE_APP_SOFT_CODE_PAGE){
           vm.$router.push({ name: "softtoken"})
           
        } else if(nextPage == process.env.VUE_APP_HOME_PAGE){
            PRE_HTTP_API.post('/auth/mfatoken').then(response => {
              sessionStorage.removeItem('expDate')
              sessionStorage.removeItem('pre-web-token')

              var expDate = new Date();
              let expDateStorage = expDate.getTime() + (response.data.expires_in*1000) - (60*1000)
              sessionStorage.setItem('expDate',expDateStorage)
              sessionStorage.setItem('web-token',response.data.access_token)
              
              vm.userAdditionalInfo()
          })
        }
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    countDownTimer () {
      var vm = this
      if (vm.countDown > 0) {
          setTimeout(() => {
            vm.countDown -= 1
            vm.countDownTimer()
          }, 1000) // delay 1000 milliseconds
      }else{
        vm.logout()
      }
    },
    logout() {
      var vm = this
      HTTP_API.get('/base/logoff/')
      .then(response => {
        console.log(response.data)
        cognosLaunch.logoffCognos();
        sessionStorage.clear();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },

  },
}
</script>

<style scoped>
  .vcenter {
    position: absolute;
    margin: 0;
    top: 53%;
    left: 50%;
    -ms-transform: translate(-50%, -47%);
    transform: translate(-50%, -47%);
    width: 350px;
    color: #606266;
    /* background-color: #e0dce4; */
    background-color: #f2f2f2;
  }

  .login-icon {
    padding-right: 10px;
  }

  .login-alert {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: white;
    background-color: #d80000;
  }

  .login-header {
    text-align: center;
    margin-top: 0px;
    font-family: "Calibri";
  }

  .login-form {
    border-radius: 5px;
    padding: 22px 22px;
    /* background: rgba(255, 255, 255, .9); */
    opacity: 0.96;
    box-shadow: 0 2px 6px 1px #666666;
  }

  a:hover {
	cursor: pointer;
  }

</style>
